var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPieces(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 24,
    viewBox: "0 0 132 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 2.5,
    stroke: "#E2E8F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2839 9.62014L11.9999 12.0002M11.9999 12.0002L7.71585 9.62014M11.9999 12.0002V16.7882M16.5359 14.0457V9.95465C16.5359 9.78196 16.5359 9.69561 16.5104 9.6186C16.4879 9.55047 16.4511 9.48793 16.4025 9.43517C16.3475 9.37553 16.2721 9.33359 16.1211 9.24973L12.3915 7.17773C12.2485 7.09832 12.1771 7.05861 12.1014 7.04305C12.0344 7.02927 11.9653 7.02927 11.8984 7.04305C11.8227 7.05861 11.7512 7.09832 11.6083 7.17773L7.87864 9.24973C7.72769 9.33359 7.65221 9.37553 7.59724 9.43517C7.54862 9.48793 7.51182 9.55047 7.48931 9.6186C7.46387 9.69561 7.46387 9.78196 7.46387 9.95465V14.0457C7.46387 14.2184 7.46387 14.3047 7.48931 14.3817C7.51182 14.4499 7.54862 14.5124 7.59724 14.5651C7.65221 14.6248 7.72769 14.6667 7.87864 14.7506L11.6083 16.8226C11.7512 16.902 11.8227 16.9417 11.8984 16.9573C11.9653 16.9711 12.0344 16.9711 12.1014 16.9573C12.1771 16.9417 12.2485 16.902 12.3915 16.8226L16.1211 14.7506C16.2721 14.6667 16.3475 14.6248 16.4025 14.5651C16.4511 14.5124 16.4879 14.4499 16.5104 14.3817C16.5359 14.3047 16.5359 14.2184 16.5359 14.0457Z",
    stroke: "black",
    strokeWidth: 1.008,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2679 10.7397L9.73193 8.21973",
    stroke: "black",
    strokeWidth: 1.008,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieces);
export default __webpack_public_path__ + "static/media/pieces.4678b074911115026a7b04898c318ab8.svg";
export { ForwardRef as ReactComponent };